export enum DATA_QA {
  ROOT = 'dnc-csv-upload',
  CONTAINER = 'dnc-csv-upload__container',
  FILE_INPUT = 'dnc-csv-upload__file-input',
  FILE_NAME = 'dnc-csv-upload__file-name',
  UPLOAD_LINK = 'dnc-csv-upload__upload-link',
  HEADERS = 'dnc-csv-upload__headers',
  UPLOAD_ANOTHER = 'dnc-csv-upload__upload-another',
  CLEAR = 'dnc-csv-upload__clear',
  ERROR_MESSAGE = 'dnc-csv-upload__error-message',
  DOWNLOAD_TEMPLATE = 'dnc-csv-upload__download-template',
}

/**
 * Template data for DNC CSV download
 * Includes all possible DNC fields with example data
 */
export const DNC_TEMPLATE_DATA = [
  [
    'phone_number',
    'do_not_call',
    'do_not_text',
    'do_not_call_opt_out_date',
    'do_not_call_expiration_date',
    'do_not_text_opt_out_date',
    'do_not_text_expiration_date',
    'scope',
    'consent',
    'validity',
    'timezone',
    'tags',
  ],
  [
    '+14155552345 ',
    'true',
    'false',
    '2024-01-15',
    '2025-01-15',
    '',
    '',
    'powerdialer',
    'implied',
    'good',
    'US/Pacific',
    'campaign_2024',
  ],
  [
    '+12125552345',
    'yes',
    'yes',
    '2024-02-01',
    '',
    '2024-02-01',
    '2024-08-01',
    'company',
    'written_consent',
    'unverified',
    'US/Eastern',
    'high_priority,vip',
  ],
  [
    '+13105556789',
    '1',
    '0',
    '2024-03-10',
    '2024-12-31',
    '',
    '',
    'campaigns',
    'revoked',
    'disconnected',
    'UTC',
    '',
  ],
];
